import { useState, useMemo } from "react";
import Fuse from "fuse.js";

const useFuseSearch = (items, keys, options = {}) => {
  const [query, setQuery] = useState("");

  const defaultOptions = {
    keys,
    threshold: 0.3,
    ...options,
  };

  const fuse = useMemo(() => new Fuse(items, defaultOptions), [items, defaultOptions]);

  const results = useMemo(() => {
    if (!query.trim()) return items;
    return fuse.search(query).map((result) => result.item);
  }, [query, items]);

  return { query, setQuery, results };
};

export default useFuseSearch;
